import type { View } from "../models/TrendingModelsV2";

export const MAX_VIEW_NAME_LENGTH = 100;

export const isDuplicateViewName = (
	viewName: string,
	views: View[],
	excludeViewId: number | null = null,
): boolean => {
	const normalized = viewName.trim().toLowerCase();

	return views.some(
		(view) =>
			view.ViewId !== excludeViewId &&
			view.ViewName.trim().toLowerCase() === normalized,
	);
};

export const getViewNameError = (
	viewName: string,
	views: View[] = [],
	excludeViewId: number | null = null,
): string => {
	const trimmed = viewName.trim();

	if (!trimmed) return "View name is required";
	if (trimmed.length > MAX_VIEW_NAME_LENGTH) {
		return `Maximum length is ${MAX_VIEW_NAME_LENGTH} characters`;
	}
	if (isDuplicateViewName(trimmed, views, excludeViewId)) {
		return "A view with this name already exists";
	}

	return "";
};
